import React from "react";
import { withRouter } from "react-router-dom";
import axios from "axios";
import Cookies from "js-cookie";
import { firstAccessibleRoute } from "../utils/accessControl";

import "./Login.css";

class Login extends React.Component {
  state = {
    email: "",
    password: "",
    showPassword: false,
    loading: false,
    error: "",
  };

  handleChange = event => {
    this.setState({ [event.target.name]: event.target.value, error: "" });
  };

  togglePassword = () => {
    this.setState(currentState => ({ showPassword: !currentState.showPassword }));
  };

  getErrorMessage = error => {
    const responseError = error?.response?.data?.errors;

    if (typeof responseError === "string") return responseError;
    if (responseError && typeof responseError === "object") {
      const firstError = Object.values(responseError)[0];
      return Array.isArray(firstError) ? firstError[0] : String(firstError);
    }

    if (!error?.response) {
      return "Tidak dapat terhubung ke server. Periksa koneksi dan coba kembali.";
    }

    return "Email atau password tidak valid.";
  };

  handleSubmit = async event => {
    event.preventDefault();
    const { email, password } = this.state;

    if (!email.trim() || !password) {
      this.setState({ error: "Email dan password wajib diisi." });
      return;
    }

    this.setState({ loading: true, error: "" });

    try {
      const response = await axios.post(global.variable.LINK_API + "auth/login", {
        email: email.trim(),
        password,
      });
      const expiresAt = new Date(Date.now() + 60 * 60 * 1000);

      Cookies.set("access_admin", response.data.data.access_token, { expires: expiresAt });
      Cookies.set("refresh_token", "222");
      localStorage.setItem("menu", JSON.stringify(response.data.menu || []));
      localStorage.setItem("admin_user", JSON.stringify(response.data.user || null));
      window.location.assign(firstAccessibleRoute(response.data.menu));
    } catch (error) {
      this.setState({ error: this.getErrorMessage(error) });
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const { email, password, showPassword, loading, error } = this.state;

    return (
      <main className="login-page">
        <section className="login-showcase" aria-label="SPIN Management Portal overview">
          <div className="login-showcase__glow login-showcase__glow--one" />
          <div className="login-showcase__glow login-showcase__glow--two" />

          <div className="login-brand">
            <span className="login-brand__mark"><img src="/payment-console-icon.svg" alt="" /></span>
            <div>
              <strong>SPIN Management Portal</strong>
              <span>Unified Administration Workspace</span>
            </div>
          </div>

          <div className="login-showcase__content">
            <span className="login-showcase__eyebrow">
              <i className="fas fa-layer-group" /> UNIFIED OPERATIONS PLATFORM
            </span>
            <h1>Satu pusat kendali untuk seluruh operasi digital.</h1>
            <p>
              Pantau aktivitas lintas platform, kelola transaksi, dan ambil keputusan
              operasional dari satu workspace yang terintegrasi.
            </p>

            <div className="login-showcase__features">
              <div>
                <span><i className="fas fa-th-large" /></span>
                <div><strong>Multi-platform</strong><small>Seluruh admin dalam satu akses</small></div>
              </div>
              <div>
                <span><i className="fas fa-chart-pie" /></span>
                <div><strong>Insight terpusat</strong><small>Data operasional lebih terarah</small></div>
              </div>
              <div>
                <span><i className="fas fa-user-shield" /></span>
                <div><strong>Kontrol aman</strong><small>Akses sesuai otorisasi tim</small></div>
              </div>
            </div>

            <div className="login-platforms" aria-label="Platform yang dikelola">
              <span>PLATFORM WORKSPACE</span>
              <div>
                <strong><i className="fas fa-shopping-bag" /> 1Toko</strong>
                <strong><i className="fas fa-mug-hot" /> Bursa Kopi</strong>
                <strong><i className="fas fa-school" /> Kliksekolah</strong>
                <strong><i className="fas fa-project-diagram" /> SCM 360</strong>
              </div>
            </div>
          </div>

          <p className="login-showcase__footer">Management intelligence • Secure access • Centralized control</p>
        </section>

        <section className="login-form-section">
          <div className="login-form-mobile-brand">
            <span className="login-brand__mark"><img src="/payment-console-icon.svg" alt="" /></span>
            <strong>SPIN Management Portal</strong>
          </div>

          <div className="login-card">
            <div className="login-card__header">
              <span className="login-card__icon"><i className="fas fa-lock" /></span>
              <h2>Selamat datang kembali</h2>
              <p>Masuk ke workspace administrator terintegrasi.</p>
            </div>

            {error && (
              <div className="login-alert" role="alert">
                <i className="fas fa-exclamation-circle" />
                <span>{error}</span>
              </div>
            )}

            <form onSubmit={this.handleSubmit} noValidate>
              <label className="login-field">
                <span>Alamat email</span>
                <div className="login-field__control">
                  <i className="far fa-envelope" />
                  <input
                    type="email"
                    name="email"
                    value={email}
                    onChange={this.handleChange}
                    autoComplete="username"
                    placeholder="nama@perusahaan.com"
                    disabled={loading}
                  />
                </div>
              </label>

              <label className="login-field">
                <span>Password</span>
                <div className="login-field__control">
                  <i className="fas fa-key" />
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    value={password}
                    onChange={this.handleChange}
                    autoComplete="current-password"
                    placeholder="Masukkan password"
                    disabled={loading}
                  />
                  <button
                    type="button"
                    className="login-field__toggle"
                    onClick={this.togglePassword}
                    aria-label={showPassword ? "Sembunyikan password" : "Tampilkan password"}
                    disabled={loading}
                  >
                    <i className={showPassword ? "far fa-eye-slash" : "far fa-eye"} />
                  </button>
                </div>
              </label>

              <div className="login-card__security-note">
                <i className="fas fa-shield-alt" />
                Sesi Anda dilindungi dan akan berakhir otomatis.
              </div>

              <button type="submit" className="login-submit" disabled={loading}>
                {loading ? (
                  <><span className="login-submit__spinner" /> Memverifikasi akun...</>
                ) : (
                  <>Masuk ke Management Portal <i className="fas fa-arrow-right" /></>
                )}
              </button>
            </form>

            <p className="login-card__help">
              Mengalami kendala akses? Hubungi administrator sistem.
            </p>
          </div>

          <p className="login-form-section__copyright">
            &copy; {new Date().getFullYear()} SPIN Management Portal. All rights reserved.
          </p>
        </section>
      </main>
    );
  }
}

export default withRouter(Login);
